import { render, staticRenderFns } from "./BwinBanner.vue?vue&type=template&id=1e8f8c0c"
import script from "./BwinBanner.vue?vue&type=script&lang=js"
export * from "./BwinBanner.vue?vue&type=script&lang=js"
import style0 from "./BwinBanner.vue?vue&type=style&index=0&id=1e8f8c0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports